import { convertDatesToISO, getHeaders } from '@/config/aux'
import { Locations } from '../models/locations'
import { LocationsStateType } from './state'
import axios from 'axios'

export interface LocationsActionsType {
  getLocations(): Promise<void>
  getLocationsByCode(code: string): Promise<void>
  getLocationsByCompanyId(companyId: string): Promise<Locations[]>
  postLocations(locations: Locations): Promise<void>
  putLocations(locations: Locations): Promise<void>
  deleteLocations(id: string): Promise<void>
}

export const LocationsActions = {
  async getLocations(this: LocationsStateType) {
    try {
      this.locations = []
      const query = `${process.env.VUE_APP_URL_BASE}/locations`
      await axios.get(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          response.data.forEach((location: Locations) => {
            this.locations.push(location)
          })
        }
      })
    } catch (error) {
      console.error('Error getting Locations', error)
    }
  },
  async getLocationsByCode(this: LocationsStateType, code: string) {
    try {
      this.location = null
      const query = `${process.env.VUE_APP_URL_BASE}/locations/code/${code}`
      await axios.get(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          this.location = response.data
        }
      })
    } catch (error) {
      console.error('Error getting Locations by code', error)
    }
  },
  async getLocationsByCompanyId(this: LocationsStateType, companyId: string): Promise<Locations[]> {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/companies/${companyId}/locations`
      const response = await axios.get(query, { headers: getHeaders() })
      
      if (response.status === 200 && response.data && Array.isArray(response.data)) {
        this.locations = response.data
        return response.data
      }
      return []
    } catch (error) {
      console.error('Error getting Locations by companyId', error)
      return []
    }
  },
  async postLocations(this: LocationsStateType, locations: Locations) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/locations`
      const data = convertDatesToISO(locations.toPlainObject())

      await axios.post(query, data, { headers: getHeaders() }).then(response => {
        if (response.status === 201) {
          // this.locations.push(locations)
        }
      })
    } catch (error) {
      console.error('Error posting Locations', error)
    }
  },
  async putLocations(this: LocationsStateType, locations: Locations) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/locations`
      const data = convertDatesToISO(locations.toPlainObject())

      await axios
        .put(query, data, {
          headers: {
            ...getHeaders(),
            'Content-Type': 'application/json',
          },
        })
        .then(response => {
          if (response.status === 200) {
            //this.locations = this.locations.map(s => (s.id === locations.id ? locations : s))
          }
        })
    } catch (error) {
      console.error('Error updating Locations', error)
    }
  },
  async deleteLocations(this: LocationsStateType, id: string) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/locations/${id}`
      await axios.delete(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          //this.locations = this.locations.filter(s => s.id !== id)
        }
      })
    } catch (error) {
      console.error('Error deleting Locations', error)
    }
  },
}
